import PublicViewPage from "./PrivateViewPage";

export default PublicViewPage;